class ShiftController implements ng.IComponentController {

    constructor(
    ) {
        'ngInject';
    }

}

export const customerShiftComponent: ng.IComponentOptions = {
    controller: ShiftController,
    template: <string>require('./shift.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/customerShifts/shift.component.ts